export class DeclineWorkOrderRequest {

    public workOrderId: string = "";

    public comment: string | null = null;
}